import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMeta = useCallback(async () => {
    const m = await api.get("/meta");
    setMeta(m.data);
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      await loadMeta();
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [loadMeta]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (u) => {
    setUser(u);
    await loadMeta();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* session already gone */ }
    setUser(null);
    setMeta(null);
  };

  return (
    <AuthCtx.Provider value={{ user, meta, loading, login, logout, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
